import styled from 'styled-components'
import { injectModifiers } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

const A = styled.a`
  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export default A
